"use client";

import { Lock, Eye, RefreshCw, Shield } from "lucide-react";

const securityData = [
  {
    icon: Lock,
    title: "Your Data is Locked",
    desc: "Protected when stored and when sent",
  },
  {
    icon: Eye,
    title: "Control Who Sees What",
    desc: "Decide which team members can access information",
  },
  {
    icon: RefreshCw,
    title: "Daily Backups",
    desc: "Automatic copies to keep your work safe",
  },
  {
    icon: Shield,
    title: "Privacy First",
    desc: "We only collect what we need",
  },
];

export function SecuritySection() {
  return (
    <section className="security_section">
      {/* Background Circles */}
      <div className="security_circle security_circle_top"></div>
      <div className="security_circle security_circle_bottom"></div>

      <div className="security_container">
        <div className="security_grid">
          {securityData.map((item, index) => (
            <div key={index} className="security_card">
              <div className="Security_Maintain_Style">
                <div className="security_iconBox">
                  <item.icon className="security_icon" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="security_cardTitle">{item.title}</h3>
                </div>
              </div>
              <p className="security_cardDesc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
